import React from 'react';
import FAQCard from './FAQCard';

const sectionStyles = {
  konto: { accent: '#3B6FD4', bg: 'rgba(59,111,212,0.04)', label: 'KONTO' },
  fakturering: { accent: '#E8521A', bg: 'rgba(232,82,26,0.04)', label: 'FAKTURERING' },
  bomkalkulator: { accent: '#2A9D8F', bg: 'rgba(42,157,143,0.04)', label: 'BOMKALKULATOR' },
  teknisk: { accent: '#8B5CF6', bg: 'rgba(139,92,246,0.04)', label: 'TEKNISK STØTTE' },
};

const FAQSection = ({ categoryId, title, description, faqs, imageUrl, imageAlt }) => {
  const style = sectionStyles?.[categoryId] || sectionStyles?.konto;

  return (
    <div style={{ marginBottom: '80px' }} id={categoryId}>
      {/* Section header with diagonal cut */}
      <div style={{
        background: style?.bg,
        borderLeft: `4px solid ${style?.accent}`,
        padding: '40px 48px',
        marginBottom: '2px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Background label */}
        <div style={{
          position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)',
          fontFamily: 'Syne, sans-serif', fontSize: '6rem', fontWeight: 800,
          color: style?.accent, opacity: 0.04, letterSpacing: '-0.05em',
          pointerEvents: 'none', userSelect: 'none'
        }}>{style?.label}</div>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '48px', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: '280px' }}>
            <div style={{
              fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem', fontWeight: 700,
              color: style?.accent, letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '12px'
            }}>{style?.label}</div>
            <h2 style={{
              fontFamily: 'Syne, sans-serif', fontSize: 'clamp(1.5rem, 3vw, 2.25rem)',
              fontWeight: 800, color: '#EEF0F2', letterSpacing: '-0.03em',
              lineHeight: 1.1, margin: 0, marginBottom: '12px'
            }}>{title}</h2>
            <p style={{
              fontFamily: 'Inter, sans-serif', fontSize: '0.9375rem',
              color: 'rgba(138,149,163,0.7)', lineHeight: 1.7, margin: 0, maxWidth: '480px'
            }}>{description}</p>
          </div>
          {imageUrl && (
            <div style={{
              width: '200px', height: '130px', overflow: 'hidden',
              flexShrink: 0, border: `1px solid ${style?.accent}22`
            }}>
              <img src={imageUrl} alt={imageAlt}
                style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'saturate(0.5) brightness(0.7)' }}
              />
            </div>
          )}
        </div>
      </div>
      {/* FAQ cards */}
      <div>
        {faqs?.map((faq, i) => (
          <FAQCard
            key={i}
            index={i}
            question={faq?.question}
            answer={faq?.answer}
            category={categoryId}
            relatedLinks={faq?.relatedLinks}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
